import { DashboardAppData } from '@models/dashboard'
import { RootState, useAppSelector } from '@store/index'

export const useAppData = (): DashboardAppData => useAppSelector((state: RootState) => state.appState.appData)
